import { render, staticRenderFns } from "./Charges.vue?vue&type=template&id=a8610f20"
import script from "./Charges.vue?vue&type=script&lang=js"
export * from "./Charges.vue?vue&type=script&lang=js"
import style0 from "./Charges.vue?vue&type=style&index=0&id=a8610f20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports